import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { taskManagementInterface, TaskManagementService } from './service/task-management.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { ApproversGroupService } from '../../customer/approvers-group/service/approvers-group.service';
import { faChevronDown, faChevronUp, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { catchError, forkJoin, of } from 'rxjs';
import { ClassificationService } from '../../classification/classification/service/classification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';

@Component({
	selector: 'register-form-task-management',
	templateUrl: './task-management.component.html',
	styleUrls: ['./task-management.component.scss'],
})
export class TaskManagementComponent implements OnInit {
	icons = {
		faChevronDown: faChevronDown,
		faChevronUp: faChevronUp,
		faTrash: faTrash,
		faPlus: faPlus,
	};

	labels: any = {
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_preencha_campo_obrigatorio: 'Please fill all the mandatory fields',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_an_errour_occour: 'An error occurred. Please try again',
		lbl_gerenciamento_de_tarefas: 'Task Management',
		lbl_geral_selecione: 'SELECT',
		lbl_geral_deletado_com_sucesso: 'Successfully deleted',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_severidade: 'Severity',
		lbl_geral_falha_criacao_atualizacao_tarefa: 'There was a failure in creating or updating the task',
		lbl_geral_excluir: 'Delete',
		lbl_geral_nome: 'Name',
		lbl_geral_classificacao_nao_disponivel_para_tipo_servico:
			'It was not possible to create this task because the defined classification is not available for the chosen service type',
		lbl_security_nenhum_registro: 'No records found',
	};

	constructor(
		private LabelsService: LabelsService,
		private notificationService: NotificationService,
		private taskManagementService: TaskManagementService,
		private ApproversGroupService: ApproversGroupService,
		private ClassificationService: ClassificationService,
		public ProfileService: ProfileService
	) {}

	isLabelsLoading = true;
	isDataLoading = false;
	isTemplateLoading = false;
	disableCheckbox = false;
	disableCheckbox1 = false;
	disableSelect = false;
	// showRequestClassification: boolean = false;
	isScopeLoading = false;
	isTopicLoading = false;
	isCategoryLoading = false;
	isSolutionAreaLoading = false;

	selectedTab = 'management';

	tasks: taskManagementInterface[] = [];

	solutionAreas: any[] = [];
	solutionAreasByServiceType: any[] = [];
	severities: any[] = [];
	approversGroups: any[] = [];
	templates: any[] = [];
	scopesOptions: any[] = [];
	categoriesOptions: any[] = [];
	topicsOptions: any[] = [];

	serviceType = '';

	serviceTypeOptions: { id: string; value: string; label: string }[] = [];
	serviceTypeFilterOptions: { id: string; value: string; label: string }[] = [];
	requestClassification: requestClassificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
		severity: [],
		impact: [],
		urgency: [],
	};

	filter: any = {
		solutionArea: '',
		scope: '',
		category: '',
		topic: '',
		serviceType: '',
		severity: '',
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'taskId', value: 'lbl_id_tarefa', colType: 'text' },
		{ name: 'groupName', value: 'lbl_geral_grupo', colType: 'text' },
		{ name: 'task', value: 'lbl_chamado_tarefa', colType: 'text' },
		{ name: 'type', value: 'lbl_chamado_tipo_tarefa', colType: 'text' },
		{ name: 'serviceType', value: 'lbl_chamado_tipo_servico', colType: 'text' },
		{ name: 'severity', value: 'lbl_geral_severidade', colType: 'text' },
		{ name: 'scopeName', value: 'lbl_geral_competencia', colType: 'text' },
		{ name: 'categoryName', value: 'lbl_asset_category', colType: 'text' },
		{ name: 'topicName', value: 'lbl_geral_topico', colType: 'text' },
	];

	classificationOptions = {
		isEditingClassification: true,
		alertField: [],
		selectedCustomer: this.ProfileService.userData().idCustomer,
		hideServiceType: [],
		hideField: [],
		idCmdb: '',
		requiredField: [],
	};

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLabelsLoading = false;
		});

		this.ClassificationService.getClassificationServiceType().subscribe((data) => {
			const formattedData = [
				{ id: '', value: '', label: this.labels.lbl_geral_selecione },
				...data.map((serviceType) => ({
					id: serviceType.id,
					value: serviceType.name,
					label: serviceType.label,
				})),
			];

			this.serviceTypeOptions = formattedData;
			this.serviceTypeFilterOptions = formattedData;
		});

		this.taskManagementService.getSolutionAreaByCustomer().subscribe((solutionAreas) => {
			this.solutionAreas = solutionAreas;
		});

		this.ApproversGroupService.getApproversGroup().subscribe((approversGroups) => {
			this.approversGroups = approversGroups;
		});

		this.taskManagementService.getSeverities().subscribe((severities) => {
			this.severities = severities;
		});
	}

	prepareReverseFilters(classification?: string): void {
		if (classification && this.filter.serviceType !== 'Problem' && this.filter.serviceType !== 'Complaint') {
			const requestClassification = JSON.parse(classification);
			this.filter.solutionArea = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].name : '';
			this.filter.scope = requestClassification.scope[0] ? requestClassification.scope[0].name : '';
			this.filter.category = requestClassification.category[0] ? requestClassification.category[0].name : '';
			this.filter.topic = requestClassification.topic[0] ? requestClassification.topic[0].name : '';
			this.filter.serviceType = requestClassification.serviceType[0] ? requestClassification.serviceType[0].name : '';
		}
	}

	getGroupTasks(search: boolean): void {
		this.tasks = [];

		if (
			search &&
			(this.filter.solutionArea !== '' ||
				this.filter.scope !== '' ||
				this.filter.category !== '' ||
				this.filter.topic !== '' ||
				this.filter.serviceType !== '' ||
				this.filter.severity !== '')
		) {
			this.isDataLoading = true;
			this.taskManagementService
				.getGroupTasks({
					solutionArea: this.filter.solutionArea,
					scope: this.filter.scope,
					category: this.filter.category,
					topic: this.filter.topic,
					serviceType: this.filter.serviceType,
					severity: this.filter.severity,
				})
				.subscribe((data) => {
					this.tasks = data;
					this.isDataLoading = false;

					if (this.tasks.length === 0) {
						this.notificationService.setNotificationMessage(this.labels.lbl_security_nenhum_registro);
					}
				});
		}
	}

	onSolutionAreaChange(task, index) {
		if (task.solutionAreaId && (task.type == 'Execution' || task.type == 'Execution - SubRequest')) {
			this.taskManagementService.getAnalystsByCustomer({ solutionAreaId: task.solutionAreaId }).subscribe((analysts) => {
				this.tasks[index].analysts = analysts;
			});
		} else {
			this.tasks[index].analysts = [];
		}
	}

	onTypeChange(task, index) {
		if (task.type == 'Authorization' || task.type == 'Review') {
			task.analyst = 0;
			this.tasks[index].analysts = [];
		} else {
			task.group = 0;
		}
	}

	onGroupChange() {
		for (const [index, task] of this.tasks.entries()) {
			if (!task.solutionAreaId) {
				task.solutionAreaId = this.requestClassification.solutionArea[0] ? this.requestClassification.solutionArea[0].id : '';
			}
		}
	}

	onSelectChange(task: any) {
		if (task.group) {
			this.disableCheckbox = true;
			this.disableCheckbox1 = true;
			task.enduserApproval = 0;
			task.enduserSupervisor = 0;
		} else {
			this.disableCheckbox = false;
			this.disableCheckbox1 = false;
			this.disableSelect = false;
		}
	}

	onServiceTypeChange(event: Event): void {
		const selectElement = event.target as HTMLSelectElement;
		const selectedValue = selectElement.value;
		this.serviceType = selectedValue;

		this.loadTemplate(selectedValue);

		if (selectedValue) {
			this.isSolutionAreaLoading = true;

			this.taskManagementService.getSolutionAreaByServiceType({ serviceType: selectedValue }).subscribe((solutionAreas) => {
				this.solutionAreasByServiceType = solutionAreas;
				this.isSolutionAreaLoading = false;
			});

			if (selectedValue == 'Service Request' || selectedValue == 'Change' || selectedValue == 'Incident') {
				this.isScopeLoading = true;
				this.taskManagementService.getScopesByServiceType({ serviceType: selectedValue }).subscribe((data) => {
					this.scopesOptions = data;
					this.isScopeLoading = false;
				});
			} else {
				this.scopesOptions = [];
			}
		} else {
			this.solutionAreasByServiceType = [];
		}
	}

	loadTemplate(item: string): void {
		if (item) {
			this.isTemplateLoading = true;
			this.taskManagementService.getTasksTemplates({ type: item }).subscribe((templates) => {
				this.templates = templates;
				this.isTemplateLoading = false;
			});
		}
	}

	loadCategory(item: string): void {
		if (
			this.serviceType &&
			item &&
			(this.serviceType == 'Service Request' || this.serviceType == 'Change' || this.serviceType == 'Incident')
		) {
			this.isCategoryLoading = true;
			this.taskManagementService.getCategoryByScope({ serviceType: this.serviceType, scope: item }).subscribe((data) => {
				this.categoriesOptions = data;
				this.isCategoryLoading = false;
			});
		} else {
			this.categoriesOptions = [];
		}
	}

	loadTopic(item: string): void {
		if (
			this.serviceType &&
			item &&
			(this.serviceType == 'Service Request' || this.serviceType == 'Change' || this.serviceType == 'Incident')
		) {
			this.isTopicLoading = true;
			this.taskManagementService.getTopicByCategory({ serviceType: this.serviceType, category: item }).subscribe((data) => {
				this.topicsOptions = data;
				this.isTopicLoading = false;
			});
		} else {
			this.topicsOptions = [];
		}
	}

	onCheckboxChange(task: any, checkboxName: string, value: boolean) {
		task[checkboxName] = value;
		if (value) {
			if (checkboxName == 'enduserApproval') {
				task.enduserSupervisor = 0;
				task.group = 0;
				this.disableCheckbox1 = true;
				this.disableSelect = true;
			} else if (checkboxName == 'enduserSupervisor') {
				task.enduserApproval = 0;
				task.group = 0;
				this.disableCheckbox = true;
				this.disableSelect = true;
			}
		} else {
			// Ensure that all fields are enabled when a checkbox is unchecked
			if (!task.enduserApproval && !task.enduserSupervisor) {
				this.disableCheckbox = false;
				this.disableCheckbox1 = false;
				this.disableSelect = false;
			}
		}
	}

	checkRequiredFields(temporary: taskManagementInterface[]): boolean {
		let fieldsFilled = true; // Inicialize como true e altere para false se qualquer campo obrigatório estiver faltando.

		for (const element of temporary) {
			// Verifique se template não está preenchido
			if (element.template == 0 || element.template == '') {
				if (
					element.taskId == 0 ||
					element.task == '' ||
					element.predecessor == '' ||
					element.type == '' ||
					((element.type == 'Execution' || element.type == 'Execution - SubRequest') &&
						(element.solutionAreaId == '' || element.analyst == 0))
					// || ((element.type == 'Review' || element.type == 'Authorization') && (element.group == '' || !element.enduserApproval || !element.enduserSupervisor))
				) {
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
					fieldsFilled = false;
				}
			} else {
				// Verifique se template está preenchido
				if (element.serviceType == '' || element.solutionAreaMock == '' || element.template == 0) {
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
					fieldsFilled = false;
				} else if ((element.serviceType == 'Problem' || element.serviceType == 'Incident') && element.severity == '') {
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
					fieldsFilled = false;
				}
			}
		}

		return fieldsFilled;
	}

	clearInputs(isNew: boolean): void {
		if (isNew) {
			this.tasks = [
				{
					analyst: 0,
					analysts: [],
					category: '',
					confirmDelete: false,
					description: '',
					enduserApproval: 0,
					enduserSupervisor: 0,
					expanded: false,
					group: 0,
					groupName: '',
					predecessor: '',
					required: 0,
					scope: '',
					serviceType: '',
					serviceTypeId: '',
					solutionAreaMock: '',
					severity: '',
					sla: 0,
					slaId: 0,
					slavip: 0,
					solutionArea: '',
					solutionAreaId: '',
					task: '',
					taskId: 0,
					template: 0,
					topic: '',
					type: '',
					uploadRequired: 0,
					urgentChange: 0,
					waitingFinish: 0,
				},
			];

			this.filter = {
				solutionArea: '',
				scope: '',
				category: '',
				topic: '',
				serviceType: '',
				severity: '',
			};
		} else {
			this.filter = {
				solutionArea: '',
				scope: '',
				category: '',
				topic: '',
				serviceType: '',
				nameTask: '',
			};
		}
	}

	clearFilterResults(): void {
		this.tasks = [];
		this.filter.serviceType = '';
		this.filter.severity = '';
		this.filter.solutionArea = '';
		this.filter.topic = '';
		this.filter.scope = '';
		this.filter.category = '';
	}

	addTask() {
		this.tasks.push({
			analyst: 0,
			analysts: [],
			category: this.tasks[0].category ? this.tasks[0].category : '',
			confirmDelete: false,
			description: '',
			enduserApproval: 0,
			enduserSupervisor: 0,
			expanded: false,
			group: 0,
			groupName: '',
			predecessor: '',
			required: 0,
			scope: this.tasks[0].scope ? this.tasks[0].scope : '',
			serviceType: this.tasks[0].serviceType ? this.tasks[0].serviceType : '',
			serviceTypeId: this.tasks[0].serviceTypeId ? this.tasks[0].serviceTypeId : '',
			severity: this.tasks[0].severity ? this.tasks[0].severity : '',
			sla: this.tasks[0].sla ? this.tasks[0].sla : 0,
			slaId: this.tasks[0].slaId ? this.tasks[0].slaId : 0,
			slavip: this.tasks[0].slavip ? this.tasks[0].slavip : 0,
			solutionArea: '',
			solutionAreaId: '',
			solutionAreaMock: this.tasks[0].solutionAreaMock ? this.tasks[0].solutionAreaMock : '',
			task: '',
			taskId: 0,
			template: 0,
			topic: this.tasks[0].topic ? this.tasks[0].topic : '',
			type: '',
			uploadRequired: 0,
			urgentChange: 0,
			waitingFinish: 0,
		});

		this.onGroupChange();
	}

	saveTasks(): void {
		if (!this.checkRequiredFields(this.tasks)) {
			return;
		}

		const requests = [];
		let slaId: string;

		if (this.tasks[0].template == 0 && !this.tasks[0].id) {
			const firstSolutionAreaId =
				this.tasks.length > 0 ? this.tasks[0].solutionAreaId : this.requestClassification.solutionArea[0]?.id;

			if (firstSolutionAreaId) {
				for (let index = 0; index < this.tasks.length; index++) {
					if (!this.tasks[index].solutionAreaId) {
						this.tasks[index].solutionAreaId = firstSolutionAreaId;
					}
				}
			}
		}

		for (let index = 0; index < this.tasks.length; index++) {
			const task = this.tasks[index];

			if (task.id) {
				requests.push(
					this.taskManagementService.updateTask(task).pipe(
						catchError((error) => {
							console.error('Error updating task:', error);
							return of(null); // Retorna um observable vazio em caso de erro
						})
					)
				);
			} else {
				requests.push(
					this.taskManagementService.postTask(task).pipe(
						catchError((error) => {
							console.error('Error creating task:', error);
							return of(null); // Retorna um observable vazio em caso de erro
						})
					)
				);
			}
		}

		forkJoin(requests).subscribe({
			next: (results) => {
				results[0].filter((result) => {
					if (result.message && result.message.includes('slaID')) {
						const slaIdMatch = result.message.match(/slaID: (\d+)/);
						if (slaIdMatch) {
							const slaId = slaIdMatch[1];
							this.getTasksBySlaId(slaId);
						}
					}
				});

				if (Array.isArray(results[0]) && results[0][0] && results[0][0].status) {
					const firstResultStatus = results[0][0].status;

					if (firstResultStatus === 'Ok') {
						const message = this.tasks.some((task) => task.id)
							? this.labels.lbl_successful_updated
							: this.labels.lbl_geral_criado_com_sucesso;
						this.notificationService.setNotificationMessage(message);

						if (this.tasks[0].template != 0) {
							this.selectedTab = 'management';
						}
					} else {
						this.notificationService.setNotificationMessage(
							this.labels.lbl_geral_classificacao_nao_disponivel_para_tipo_servico
						);
						this.clearInputs(true);
					}
				}
			},
			error: (error) => {
				console.error('Error in forkJoin:', error);
				this.notificationService.setNotificationMessage(this.labels.lbl_geral_falha_criacao_atualizacao_tarefa);
			},
		});
	}

	getTasksBySlaId(slaId: string): void {
		this.taskManagementService.getGroupTasks({ slaId: slaId, serviceType: this.tasks[0].serviceType }).subscribe(
			(data) => {
				this.tasks = data;

				for (const [index, task] of this.tasks.entries()) {
					if (task.solutionAreaId && (task.type === 'Execution' || task.type === 'Execution - SubRequest')) {
						this.taskManagementService.getAnalystsByCustomer({ solutionAreaId: task.solutionAreaId }).subscribe((analysts) => {
							this.tasks[index].analysts = analysts;
						});
					} else {
						this.tasks[index].analysts = [];
					}
				}
			},
			(error) => {
				console.error('Error fetching tasks by SLA ID:', error);
			}
		);
	}

	toggleTask(index: number) {
		this.tasks[index].expanded = !this.tasks[index].expanded;
	}

	removeTask(index: number) {
		if (this.tasks[index]?.id) {
			this.taskManagementService
				.deleteTask({
					serviceType: this.filter.serviceType,
					id: this.tasks[index].id,
					type: this.tasks[index].type,
				})
				.subscribe(
					(data) => {
						this.notificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
						this.tasks.splice(index, 1); // Remove a tarefa da lista
						if (this.tasks.length === 0) {
							this.tasks.push({
								serviceType: '',
							});
						}
					},
					(error) => {
						console.error('Erro ao deletar a tarefa', error);
					}
				);
		} else {
			this.tasks.splice(index, 1); // Remove a tarefa da lista mesmo que ela não tenha um ID
		}
	}

	removeTaskTemplate(item: taskManagementInterface): void {
		if (item.id && item.template) {
			this.taskManagementService
				.deleteTask({ serviceType: item.serviceType, id: item.id, templateId: item.template })
				.subscribe((data) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
					this.selectedTab = 'management';
					this.clearInputs(false);
				});
		}
	}

	openUpdatedForm(item: taskManagementInterface): void {
		const selectedSlaId = item.slaId;
		this.selectedTab = 'create';
		this.tasks = this.tasks.filter((task) => task.slaId == selectedSlaId);

		const event = { target: { value: this.tasks[0].serviceType } } as unknown as Event;

		this.onServiceTypeChange(event);

		if (this.tasks[0].scope) {
			this.loadCategory(this.tasks[0].scope);
		}

		if (this.tasks[0].category) {
			this.loadTopic(this.tasks[0].category);
		}

		if (this.tasks[0].template) {
			this.loadTemplate(this.tasks[0].serviceType);
		}

		for (const [index, task] of this.tasks.entries()) {
			if (task.solutionAreaId && (task.type === 'Execution' || task.type === 'Execution - SubRequest')) {
				this.taskManagementService.getAnalystsByCustomer({ solutionAreaId: task.solutionAreaId }).subscribe((analysts) => {
					this.tasks[index].analysts = analysts;
				});
			} else {
				this.tasks[index].analysts = [];
			}
		}
	}
}
